import { render } from "./Update.vue?vue&type=template&id=0c7bf9dd&scoped=true"
import script from "./Update.vue?vue&type=script&lang=js"
export * from "./Update.vue?vue&type=script&lang=js"

import "./Update.vue?vue&type=style&index=0&id=0c7bf9dd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0c7bf9dd"

export default script